export default function blockMapClickZones() {
    document.querySelectorAll('.block-map').forEach(function(block) {
        new BlockMapClickZones(block);
    });
}

class BlockMapClickZones {
    block = null;

    constructor(block) {
        this.block = block;
        this.initClickZones();
    }

    initClickZones() {
        const points = this.block.querySelectorAll('.map_punkt');

        points.forEach(punkt => {
            punkt.addEventListener('click', () => {
                const url = punkt.dataset.url;
                if (url) {
                    window.location.href = url;
                }
            });

            // punkt.addEventListener('mouseover', () => {
            //     punkt.classList.add('hovered');
            // });
            //
            // punkt.addEventListener('mouseout', () => {
            //     punkt.classList.remove('hovered');
            // });
        });
    }
}
